import type { ProjectData } from '../../types';
import Component from './content.mdx';

const data: ProjectData = {
    slug: 'telesite',
    title: 'Telesite Platform',
    description: 'Telesite is a platform that allows users to create and manage their own websites. It provides a simple and intuitive interface for users to design and customize their websites, as well as tools for managing content and tracking performance.',
    fileName: 'content.mdx',
    markdown: Component,
    info: {
        stack: [
            'React',
            'TypeScript',
            'Material-UI',
            'Node.js',
            'Next.js',
            'Docker',
            'PostgreSQL',
        ],
        url: 'https://telesite.unrealos.com',
    },
};

export default data;
